<script lang="ts">
  import {
    CLASSES,
    abilityClass,
    abilityDef,
    type AbilityId,
  } from '@arena/shared';

  let {
    abilityId,
    active = false,
  }: {
    abilityId: AbilityId;
    active?: boolean;
  } = $props();

  const ability = $derived(abilityDef(abilityId));
  const owner = $derived(abilityClass(abilityId));
  const resource = $derived(owner ? CLASSES[owner].resource : '');
  const range = $derived(
    ability.range
      ? `${ability.minRange ? `${ability.minRange}–` : ''}${ability.range} yd range`
      : ability.target === 'enemy'
        ? 'Melee range'
        : '',
  );
  const cast = $derived(
    ability.channel
      ? 'Channeled'
      : ability.castTime
        ? `${ability.castTime} sec cast`
        : 'Instant',
  );
  const cooldown = $derived(
    !ability.cooldown
      ? ''
      : ability.cooldown >= 60
        ? `${ability.cooldown / 60} min cooldown`
        : `${ability.cooldown} sec cooldown`,
  );
</script>

<div class="tooltip">
  <div class="name">{active ? `Cancel ${ability.name}` : ability.name}</div>
  {#if ability.cost || range}
    <div class="row">
      <span class="cost"
        >{ability.cost ? `${ability.cost} ${resource}` : ''}</span
      >
      <span>{range}</span>
    </div>
  {/if}
  <div class="row">
    <span>{cast}</span>
    <span>{cooldown}</span>
  </div>
  <div class="desc">{ability.description}</div>
</div>

<style>
  .tooltip {
    width: 300px;
    padding: 10px 12px;
    background: var(--panel-solid);
    border: 1px solid var(--border);
    border-radius: 6px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.6);
    font-size: 14px;
    line-height: 1.35;
  }
  .name {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }
  .row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    color: #fff;
  }
  .cost {
    text-transform: capitalize;
  }
  .desc {
    margin-top: 4px;
    color: var(--gold);
  }
</style>
